import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { setStatusSchema } from '../../../../shared/validators/schemas/set-status.schema';
import { VehicleDamageRecordDto } from '../../dtos/vehicle-damage-record.dto';
import { VehicleDamageActionEnum } from '../../enums/vehicle-damage-action.enum';
import { VehicleDamageStatusEnum } from '../../enums/vehicle-damage-status.enum';

/**
 * Validates if an action can be performed by validating the record data.
 * @param record - The record for the data validation.
 * @param action - The action to be validated.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canPerformAction = (
	record: VehicleDamageRecordDto,
	action: VehicleDamageActionEnum,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	const fixedStatuses = [
		VehicleDamageStatusEnum.PENDING,
		VehicleDamageStatusEnum.REPAIRED,
		VehicleDamageStatusEnum.IGNORED,
	];

	switch (action) {
		case VehicleDamageActionEnum.APPROVE:
			// TODO: Approval flow
			break;

		case VehicleDamageActionEnum.REJECT:
			// TODO: Approval flow
			break;

		case VehicleDamageActionEnum.IGNORE:
			validationResult = setStatusSchema(
				VehicleDamageStatusEnum.IGNORED,
				fixedStatuses,
			).validate(record, {
				abortEarly,
			});
			break;

		case VehicleDamageActionEnum.PENDING:
			validationResult = setStatusSchema(
				VehicleDamageStatusEnum.PENDING,
				fixedStatuses,
			).validate(record, {
				abortEarly,
			});
			break;

		case VehicleDamageActionEnum.REPAIR:
			validationResult = setStatusSchema(
				VehicleDamageStatusEnum.REPAIRED,
				fixedStatuses,
			).validate(record, {
				abortEarly,
			});
			break;

		case VehicleDamageActionEnum.CREATE_MAINTENANCE:
			break;

		case VehicleDamageActionEnum.ESTIMATE:
			break;

		default:
			throw new Error(`Unknown action: ${action}`);
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
